(function () {
  'use strict';
  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  /* ── comptes à rebours ── */
  function initTimer(el) {
    if (el.dataset.on) return;
    el.dataset.on = '1';
    var mins = parseInt(el.dataset.min, 10) || 10;
    var total = mins * 60000;
    var out = el.querySelector('[data-timer-c]');
    var bar = el.querySelector('[data-timer-bar]');
    var key = 'sj-timer-' + (el.dataset.key || 'd');
    var end = parseInt(sessionStorage.getItem(key) || '0', 10);
    if (!end || end - Date.now() <= 0) {
      end = Date.now() + total;
      sessionStorage.setItem(key, String(end));
    }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) {
        end = Date.now() + total;
        sessionStorage.setItem(key, String(end));
        left = total;
      }
      var m = Math.floor(left / 60000);
      var s = Math.floor(left / 1000) % 60;
      if (out) out.textContent = pad(m) + ':' + pad(s);
      if (bar) bar.style.width = (left / total * 100) + '%';
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ── bandeau défilant : pas de JS, CSS seul ── */

  /* ── galerie produit ── */
  function initGallery(el) {
    if (el.dataset.on) return;
    el.dataset.on = '1';
    var track = el.querySelector('[data-gal-t]');
    var thumbs = el.querySelectorAll('[data-gal-th]');
    if (!track) return;
    function go(i) { track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' }); }
    el.addEventListener('click', function (e) {
      var t = e.target.closest('[data-gal-th]');
      if (t) { go(parseInt(t.dataset.galTh, 10)); return; }
      var a = e.target.closest('[data-gal-ar]');
      if (!a) return;
      var d = a.dataset.galAr === 'n' ? 1 : -1;
      track.scrollBy({ left: track.clientWidth * d, behavior: 'smooth' });
    });
    track.addEventListener('scroll', function () {
      clearTimeout(track._t);
      track._t = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.toggle('on', k === i);
      }, 90);
    }, { passive: true });
  }

  /* ── variantes produit ── */
  function initProduct(form) {
    if (form.dataset.on) return;
    form.dataset.on = '1';
    var data = form.querySelector('[data-variants]');
    if (!data) return;
    var variants;
    try { variants = JSON.parse(data.textContent); } catch (e) { return; }
    var idField = form.querySelector('[name="id"]');
    var selects = form.querySelectorAll('[data-opt]');
    var root = form.closest('.pdp') || document;
    var now = root.querySelector('[data-price]');
    var was = root.querySelector('[data-compare]');
    var btn = form.querySelector('[data-submit]');
    var label = root.querySelector('[data-btn-price]');

    function money(cents) {
      return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
    }
    function sync() {
      var chosen = [];
      selects.forEach(function (s) { chosen.push(s.value); });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === chosen[i]; });
      });
      if (!v) return;
      if (idField) idField.value = v.id;
      if (now) now.textContent = money(v.price);
      if (was) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          was.textContent = money(v.compare_at_price);
          was.hidden = false;
        } else was.hidden = true;
      }
      if (label) label.textContent = money(v.price);
      if (btn) {
        btn.disabled = !v.available;
        var t = btn.querySelector('[data-btn-text]');
        if (t && !v.available) t.textContent = 'Épuisé';
      }
      if (v.featured_image_index >= 0) {
        var track = root.querySelector('[data-gal-t]');
        if (track) track.scrollTo({ left: track.clientWidth * v.featured_image_index, behavior: 'smooth' });
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.closest('[data-opt]')) sync();
    });
    sync();
  }

  /* ── quantité ── */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty]');
    if (q) {
      var input = q.parentNode.querySelector('input');
      if (!input) return;
      var v = parseInt(input.value, 10) || 1;
      v += q.dataset.qty === 'p' ? 1 : -1;
      input.value = Math.max(1, Math.min(99, v));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var p = e.target.closest('[data-pack]');
    if (p) {
      var wrap = p.closest('[data-packs]');
      if (!wrap) return;
      var total = wrap.querySelector('[data-packs-total]');
      if (total && p.dataset.packPrice) total.textContent = p.dataset.packPrice;
    }
  });

  /* ── apparition au défilement ── */
  function initReveal() {
    if (!('IntersectionObserver' in window)) return;
    var o = new IntersectionObserver(function (es, obs) {
      es.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); obs.unobserve(en.target); }
      });
    }, { threshold: 0.06, rootMargin: '0px 0px -5% 0px' });
    document.querySelectorAll('[data-reveal]').forEach(function (el, i) {
      if (el.dataset.rv) return;
      el.dataset.rv = '1';
      el.classList.add('reveal');
      el.style.transitionDelay = (Math.min(i, 4) * 60) + 'ms';
      o.observe(el);
    });
  }

  function boot() {
    document.querySelectorAll('[data-timer]').forEach(initTimer);
    document.querySelectorAll('[data-gal]').forEach(initGallery);
    document.querySelectorAll('[data-product-form]').forEach(initProduct);
    initReveal();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
